import React, { Component } from "react";

import { Element } from "react-scroll";

import Restaurante from "./Restaurante";

import axios from "axios";

export default class Restaurantes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      restaurantes: []
    };
  }

  componentDidMount = () => {
    this.loadRestaurantes();
  };

  loadRestaurantes = async () => {
    
    let res = {};
    try {
      res = await axios.get("/api/restaurantes", {
        params: {},
        headers: {
          APIKEY: "q7tXDJZX1StZAKZsKTLu5FRBs5k42vSf",
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.log(error);
    }

    let restaurantes = res.data.arrayRestaurantes;

    this.setState({ restaurantes });
  };

  render() {
    const items = this.state.restaurantes.map(function(item) {
      return <Restaurante item={item} key={item._id}/>;
    });

    return (
      <section id="restaurantes">
        <Element name="restaurantesElement" />
        <div className="container">
          <h1>Restaurantes</h1>

          <img
            className="food-and-drink__image"
            src="https://lonelyplanetimages.imgix.net/a/g/hi/t/14992701ade2a32f2fff12f02a078900-western-europe.jpg?sharp=10&amp;vib=20"
            alt="Food and drink"
          />

          <div className="food-and-drink__inner">
            <ol className="food-and-drink__list">{items}</ol>
          </div>
        </div>
      </section>
    );
  }
}
